<template>
  <modal @close="smallAlertModalHide">
    <template slot="header">
      <md-button
        class="md-simple md-danger md-just-icon md-round modal-default-button"
        @click="smallAlertModalHide"
      >
        <md-icon>clear</md-icon>
      </md-button>
      <div class="md-layout md-size-100 md-alignment-bottom-start">
        <div class="md-layout-item md-size-30">
          <md-field>
            <md-input
              v-model="filterName"
              placeholder="Tên sản phẩm"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-20">
          <md-switch v-model="isWine">Rượu vang</md-switch>
        </div>
        <div class="md-layout-item md-size-30">
          <md-switch v-model="isAccessories">Sản phẩm khác</md-switch>
        </div>
      </div>
    </template>
    <template slot="body">
      <div class="md-layout">
        <div class="md-layout-item table-products md-scrollbar md-size-60">
          <table id="customers">
            <tr>
              <th>STT</th>
              <th style="width: 120px">Mã sản phẩm</th>
              <th style="width: 120px">Tên sản phẩm</th>
              <th>Hình ảnh</th>
              <th>Loại</th>
              <th class="text-center">
                <md-checkbox
                  v-model="isCheckAll"
                  @change="changeCheckAll"
                ></md-checkbox>
              </th>
            </tr>
            <tr :key="index" v-for="(item, index) in search">
              <td>{{ index + 1 }}</td>
              <td>{{ item.data.productId }}</td>
              <td>{{ item.data.name }}</td>
              <td>
                <div class="image-container">
                  <img :src="item.data.pictureThumbnail" class="box-image" />
                </div>
              </td>
              <td>{{ item.data.tags[0] }}</td>
              <td>
                <md-checkbox
                  :value="item"
                  v-model="productSelected"
                ></md-checkbox>
              </td>
            </tr>
          </table>
        </div>
        <div class="table-products md-layout-item md-scrollbar">
          <div class="titleRight">Sản phẩm đã chọn</div>
          <transition-group name="list">
            <div
              class="md-layout product-box"
              :key="item.id"
              v-for="(item, index) in productSelected"
            >
              <div class="image-container">
                <img :src="item.data.pictureThumbnail" class="box-image" />
              </div>
              <p class="md-layout-item">
                {{
                  item.data.name.length > 30
                    ? item.data.name.substring(0, 30) + "..."
                    : item.data.name
                }}
              </p>
              <div class="removeIcon clickable" @click="removeItem(index)">
                <i class="far fa-times-circle"></i>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </template>
    <template slot="footer">
      <md-button
        class="md-dense md-danger cancelBtn"
        @click="smallAlertModalHide"
        >Hủy</md-button
      >
      <md-button class="md-success md-dense cancelBtn" @click="confirmAdd"
        >Hoàn tất</md-button
      >
    </template>
  </modal>
</template>
<script>
import { Modal } from "@/components";
import firebase from "@/services/firebase-init.js";
import { mapGetters } from "vuex";
export default {
  components: { Modal },
  props: ["listProductsSelected"],
  data() {
    return {
      isWine: true,
      isAccessories: true,
      filterName: "",
      db: {},
      listProducts: [],
      productSelected: [],
      productReplace: {},
      isCheckAll: false,
    };
  },
  async created() {
    this.db = firebase.firestore();
    this.$store.dispatch("FLAG_LOADING", true);
    let bits = localStorage.getItem("bits");
    this.listProducts = JSON.parse(JSON.stringify(this.$listProducts));
    try {
      if (this.accessories.length === 0) {
        await this.$store.dispatch("getAllAccessories");
      }
      this.listProducts = this.listProducts.concat(this.accessories);
      this.listProducts = this.listProducts.filter(
        (item) => item.data.isHide !== true
      );
      this.listProducts.forEach((wine) => {
        if (
          this.listProductsSelected.findIndex((el) => {
            return el.productId === wine.data.productId;
          }) !== -1
        ) {
          this.productSelected.push(wine);
        }
      });
      if (this.listProducts.length === this.productSelected.length)
        this.isCheckAll = true;
      this.$store.dispatch("FLAG_LOADING", false);
    } catch (error) {
      this.$messsageError("Lỗi khi tải danh sách phụ kiện");
    }
    // this.db
    //   .collection(process.env.VUE_APP_WINE + bits)
    //   .where("tags", "array-contains", "Phụ kiện")
    //   .orderBy("name")
    //   .get()
    //   .then((querySnapshot) => {
    //     querySnapshot.forEach((doc) => {
    //       this.listProducts.push({
    //         data: doc.data(),
    //         id: doc.id,
    //       });
    //     });
    //     this.listProducts = this.listProducts.filter(
    //       (item) => item.data.isHide !== true
    //     );
    //     this.listProducts.forEach((wine) => {
    //       if (
    //         this.listProductsSelected.findIndex((el) => {
    //           return el.productId === wine.data.productId;
    //         }) !== -1
    //       ) {
    //         this.productSelected.push(wine);
    //       }
    //     });
    //     if (this.listProducts.length === this.productSelected.length)
    //       this.isCheckAll = true;
    //     this.$store.dispatch("FLAG_LOADING", false);
    //   });
  },
  methods: {
    changeCheckAll() {
      if (this.isCheckAll) {
        this.listProducts.forEach((wine) => {
          this.productSelected.push(wine);
        });
      } else this.productSelected = [];
    },
    smallAlertModalHide() {
      this.$emit("smallAlertModalHide", []);
      this.productSelected = [];
    },
    confirmAdd() {
      this.$emit("smallAlertModalHide", this.productSelected);
      this.productSelected = [];
    },
    removeItem(index) {
      this.productSelected.splice(index, 1);
    },
  },
  computed: {
    ...mapGetters(["$listProducts", "accessories"]),
    search() {
      var result = [];
      if (this.isAccessories) {
        result = this.listProducts.filter(
          (item) => item.data.tags[0] == "Phụ kiện"
        );
      }
      if (this.isWine) {
        result = this.listProducts.filter(
          (item) => item.data.tags[0] == "Rượu"
        );
      }
      result = result.filter(
        (item) =>
          item.data.name
            .toLowerCase()
            .indexOf(this.filterName.toLowerCase()) !== -1
      );
      return result;
    },
  },
};
</script>
<style scoped>
.table-products {
  height: 50vh;
  overflow-y: scroll;
}
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 8px;
  max-width: 20vh;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: rgb(137, 211, 143);
  color: rgb(0, 0, 0);
  font-style: normal;
  font-weight: normal;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
}
.fixed-input {
  position: fixed;
}
.product-box {
  border-radius: 5px;
  margin: 5px;
  padding: 5px;
  background: rgb(238, 238, 238);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.image-container {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 50%;
  background: white;
}
.box-image {
  width: auto;
  height: 100%;
}
.titleRight {
  position: sticky;
  top: 0;
  padding: 12px;
  background: rgb(137, 211, 143);
  color: black;
  font-weight: 400;
  margin-left: 5px;
  z-index: 1;
  width: 100%;
  border-radius: 5px;
}
.cancelBtn {
  margin: 0 5px;
}
.removeIcon {
  color: rgb(202, 0, 0);
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>
